<template>
  <div class="config_title_hang_wraper">
    <!-- 暂时无用 -->
    <div class="config_title_hang_ele1" v-if="this.$slots['config_title_hang_ele1']">
      <slot name="config_title_hang_ele1"></slot>
    </div>
    <!-- 左侧文案提示 -->
    <div class="config_title_hang_ele2 z_ellipsis1" v-if="this.$slots['config_title_hang_ele2']">
      <slot name="config_title_hang_ele2"></slot>
    </div>


    <!-- 右侧图标提示 -->
    <div class="config_title_hang_ele3 z_ellipsis1" v-if="this.$slots['config_title_hang_ele3']">
      <slot name="config_title_hang_ele3"></slot>
    </div>
    <!-- 右侧左文字提示 -->
    <div class="config_title_hang_ele4 z_ellipsis1" v-if="this.$slots['config_title_hang_ele4']">
      <slot name="config_title_hang_ele4"></slot>
    </div>

    <!-- 右侧添加最后一个按钮 -->

    <div class="config_title_hang_ele5 z_ellipsis1" v-if="this.$slots['config_title_hang_ele5']">
      <slot name="config_title_hang_ele5_img"></slot>
      <slot name="config_title_hang_ele5"></slot>
    </div>

    <!-- 右侧第一个按钮 -->
    <div class="config_title_hang_ele6 z_ellipsis1" v-if="this.$slots['config_title_hang_ele6']">
      <slot name="config_title_hang_ele6_img"></slot>
      <slot name="config_title_hang_ele6"></slot>
    </div>


    <!-- 搜索框靠左的-->
    <div class="config_title_hang_ele7 z_ellipsis1" v-if="this.$slots['config_title_hang_ele7']">
      <slot name="config_title_hang_ele7"></slot>
    </div>

    <!-- 搜索框靠右的-->
    <div class="config_title_hang_ele8 z_ellipsis1" v-if="this.$slots['config_title_hang_ele8']">
      <slot name="config_title_hang_ele8"></slot>
    </div>

    <!-- <div class="config_title_hang_ele3 z_ellipsis1" v-if="this.$slots['config_title_hang_ele3']">
      <slot name="config_title_hang_ele3"></slot>
    </div>
    <div class="config_title_hang_ele4" v-if="this.$slots['config_title_hang_ele4']">
      <slot name="config_title_hang_ele4"></slot>
    </div>-->
  </div>
</template>

<script>
export default {}

/**使用说明
 *
 * 举例 参数
 *
 *
 */
</script>

<style>
.config_title_hang_wraper {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #f2f2f2;
  padding: 0px 10px;

  box-sizing: border-box;

  position: relative;

  font-size: 16px;
  color: #666666;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.config_title_hang_ele1 {
  display: inline-block;
  width: 21px;
  height: 60px;
  margin-right: 5px;

  /* 不知道为啥要加这个反正是要加 */
  position: relative;
  top: -24px;
}

.config_title_hang_ele1 img {
  display: inline-block;
  height: 21px;
  width: 21px;
  position: relative;
  top: 4px;
}

.config_title_hang_ele2 {
  display: inline-block;
  width: 300px;
  position: relative;
}


.config_title_hang_ele4 {
  display: inline-block;
  text-align: right;
  color: #666666;
  width: 200px;
  font-size: 16px;

  position: absolute;
  right: 30px;
}

.config_title_hang_ele3 img {
  height: 14px;
  width: 14px;
  position: absolute;
  right: 228px;
  top: 14px;
}

.config_title_hang_ele5 {
  color: #ffffff;
  /* width: 150px; */
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  border-radius: 5px;
  position: absolute;
  top: 8px;
  right: 30px;
  padding: 2px 10px;
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: var(--primary-color);

  cursor: pointer;
}

div.config_title_hang_ele5 span {
  color: #ffffff;
}

.config_title_hang_ele5:active {
  background: #a0a3a5;
}

.config_title_hang_ele5 img {
  height: 18px;
  width: 18px;
  margin-right: 3px;
}


.config_title_hang_ele6 {
  color: #ffffff;
  /* width: 150px; */
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  border-radius: 5px;
  position: absolute;
  top: 8px;
  right: 140px;
  padding: 2px 10px;
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: var(--primary-color);

  cursor: pointer;
}

div.config_title_hang_ele6 span {
  color: #ffffff;
}

.config_title_hang_ele6:active {
  background: #a0a3a5;
}

.config_title_hang_ele6 img {
  height: 18px;
  width: 18px;
  margin-right: 3px;
}

.config_title_hang_ele7 {
  /* color: #ffffff; */
  /* width: 150px; */
  font-size: 18px;

  position: absolute;
  top: -1px;
  right: 250px;


  cursor: pointer;
}

.config_title_hang_ele7 input {
  width: 140px;
  padding-left: 10px;
  border-radius: 20px;
  height: 15px;
}


.config_title_hang_ele8 {
  /* color: #ffffff; */
  /* width: 150px; */
  font-size: 18px;

  position: absolute;
  top: -1px;
  right: 50px;


  cursor: pointer;
}

.config_title_hang_ele8 input {
  width: 140px;
  padding-left: 10px;
  border-radius: 20px;
  height: 15px;
}
</style>
